import * as React from 'react';
import styles from './ad-box.module.scss';

// Slot IDs + client mirror xconvert-web/components/ui/motive/ad-slots.ts — the
// role-keyed registry for account pub-7820192138716446 (same site, same account,
// units shared by role on purpose: reporting answers "does the below-tool ROLE
// earn", not per-page fragments). Do not mint new IDs here.
export const AD_CLIENT = 'ca-pub-7820192138716446';
export const AdSlots = {
    /** Inside lists and mid-content, between blocks the user is reading. */
    inContent: '3219362107',
    /** Top of a page, above the main content. */
    pageTop: '9666235439',
    /** Directly beneath a converter's tool, where the result appears. */
    belowTool: '2097852120',
    /** Desktop side rails. Both rails share this unit — one product decision. */
    desktopRail: '1906280432',
} as const;

/**
 * Reserved-box AdSense unit (the xconvert-web motive pattern): a fixed IAB size
 * per breakpoint is reserved in CSS before the ad arrives — zero CLS — and any
 * taller creative is clipped instead of shifting content.
 *
 * Never re-renders (shouldComponentUpdate: false) and pushes exactly once on
 * mount — safe inside interactive parents that re-render on every pointer move
 * (e.g. the time-converter slider stack).
 */
export class AdBox extends React.Component<{ slot: string; variant: 'rect' | 'banner' | 'rail' }> {
    shouldComponentUpdate() { return false; }
    componentDidMount() {
        try {
            ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
        } catch (e) { /* blocked/absent loader — box stays empty, layout unchanged */ }
    }
    render() {
        const cls = this.props.variant === 'rect' ? styles['ad-rect']
            : this.props.variant === 'rail' ? styles['ad-rail']
            : styles['ad-banner'];
        return (
            <div className={`${styles['ad-box']} ${cls}`}>
                <ins className={`adsbygoogle ${cls}`}
                    style={{ display: 'inline-block' }}
                    data-ad-client={AD_CLIENT}
                    data-ad-slot={this.props.slot} />
            </div>
        );
    }
}
